import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import Loading from '../../components/loading'
import OspreyApi from '../../actions/osprey-api'
import routeMap from '../../services/route-map'
import StringTableService from '../../services/string-table'

export default function withAuthorizer(ChildComponent) {
    class withAuthorizerWrapper extends Component {
        static propTypes = {
            authorizer: PropTypes.object,
            meResult: PropTypes.object
        }

        render() {
            const { authorizer, meResult, ...otherProps } = this.props
            if (!meResult || meResult.isFetching) {
                return <Loading label="Loading user policy" />
            }

            if (meResult.error) {
                const toProp = {
                    pathname: routeMap.lookupMap.logout.route,
                    state: {
                        title: StringTableService.getString(StringTableService.keys.authenticationErrorTitle),
                        message: StringTableService.getString(StringTableService.keys.authenticationErrorMessage),
                        detail: ''
                    }
                }

                return <Redirect to={toProp} />
            }

            return (
                <ChildComponent authorizer={authorizer} {...otherProps} />
            )
        }
    }

    return connect(mapStateToProp)(withAuthorizerWrapper)
}

const mapStateToProp = (state) => {
    const { authorizer, contentByKey } = state
    const api = new OspreyApi()

    return {
        meResult: api.me.info.getState(contentByKey),
        authorizer
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-authorizer.js